import { NonIdealState } from "@blueprintjs/core";
import initialState from "core/reducers/initialState";
import React from "react";
import { connect } from "react-redux";
import PanelViewEdit from "./PanelViewEdit";

/**
 * list of active panel views with their selected variants.
 *
 * @author chris
 */

interface IPanelViewListOwnProps {
	instance: string; // panel instance
}

interface IPanelViewListStateProps {
	panelViews?: { [viewKey: string]: string; };
}

function mapStateToProps(state: typeof initialState = initialState, ownProps: IPanelViewListOwnProps): IPanelViewListStateProps {

	return {
		panelViews: state.active.views[ownProps.instance]
	};
}

type ResultProps = IPanelViewListStateProps & IPanelViewListOwnProps;

const PanelViewList: React.SFC<ResultProps> = (props) => {

	if (!props.panelViews || Object.keys(props.panelViews).length < 1) {
		return (
			<NonIdealState
				title="No Views Available"
				description="No active views found for this panel. Try navigating to the page that contains this panel."
			/>
		);
	}

	return (
		<div>
			{
				Object.entries(props.panelViews).map(([viewKey, variantId]) => (
					<PanelViewEdit
						key={viewKey}
						panelInstance={props.instance}
						viewKey={viewKey}
						viewId={variantId}
					/>
				))
			}
		</div>
	);
};

export default connect(mapStateToProps)(PanelViewList);



// WEBPACK FOOTER //
// ./src/core/components/editor/panels/PanelViewList.tsx